(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trio-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-tnav]');
  if(!root) return;
  var burger = root.querySelector('[data-burger]');
  var panel = root.querySelector('[data-mobile]');
  if(burger && panel){
    burger.addEventListener('click', function(){
      var open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      if(open){ panel.setAttribute('hidden',''); } else { panel.removeAttribute('hidden'); }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
